import React from 'react';
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types';
import {
    FormGroup,
    InputGroup,
    Button,
    ButtonToolbar,
    ControlLabel,
    FormControl,
    HelpBlock,
    ButtonGroup,
  } from 'react-bootstrap';
  import { Field,Form } from 'react-final-form';
  import { required, number, positiveNumber } from '../../../forms';
  import { RowDefinition, ColumnDefinition } from 'griddle-react';
  import StyledGriddle from '../../../components/StyledGriddle';
  //import { Field, reduxForm,formValueSelector,connect } from 'redux-form';

const sortProperties = [];
  
export const renderTextField = ({ input, label, type, meta: { touched, error, warning } }) => (
    <InputGroup>
      { label && (<ControlLabel>{label}</ControlLabel>)}
      <FormControl
        {...input}
        type={type}
      />
    </InputGroup>
  );

class HotelContactModal extends React.Component {
    constructor(props, context) {
      super(props, context);
  
      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      //this.handleSubmit = this.handleSubmit.bind(this);
      this.handleDel = this.handleDel.bind(this);
  
      this.state = {
        show: false,
        ModalData: '' 
      };
    }

    
    handleDel() {
      //console.log('handleDel called')
      this.setState({ show: true });
    }
    handleSubmitA(values) {
      //debugger;
      const initialValues = this.props.tour;
     const isNew = this.props.tour.id ? false : true;
     //return this.setState({name:})
     if (isNew) {
      return this.handleAddTour(values, initialValues);
     }
      return this.handleEditTour(values, initialValues);
    }
    onSubmit = (values) => {
      //this.props.handleSubmit(values)
    //   this.setState({ ModalData:values }, () => 
    // console.log(this.state.ModalData));
      // this.setState(
      //   {ModalData:values} 
      //   //{contact_name:values.name}
      //   // {conact_email:values.email},
      //   // { show: false }
      //   )
      //debugger;
      this.props.handleSubmit(values)
      this.setState({ show: false });  
    }
  
    handleClose() {
      //console.log('handleClose called')
      this.setState({ show: false });
    }
  
    handleShow() {
      //console.log('handleShow called')
      this.setState({ show: true });
    }
    
    render(handleSubmit) {
        const errors = {};
        //const pristine = "";
        const convertedBids = [
          {
            "id":0, 
            "name": "Hayat",
            "email": "tester@gmail.com"
          },
          {
            "id":1,
            "name": "test",
            "email": "user@gmail.com"
            
          }
        ];
        const ButtonColumn = ({ value }) => (
          <ButtonGroup>
            <Button bsStyle="info" data-item={value} onClick={this.handleShow}>
              <i className="fa fa-pencil fa-lg" />
            </Button>
            <Button bsStyle="info" data-item={value} onClick={this.handleDel}>
              <i className="fa fa-trash fa-md" />
            </Button>
          </ButtonGroup>
          );
        return (
        <div id="parent">
          
          <div className="col-md-11"><h4 className="hotel-highlight">Hotel Contacts</h4></div>   
          <div className="col-md-1">
           <FormGroup>
            <ButtonToolbar>
              <Button bsStyle="success" onClick={this.handleShow}>
                Add
              </Button>
            </ButtonToolbar>
           </FormGroup>
          </div>
          <Modal show={this.state.show} onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Add Contact</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form
              onSubmit={this.onSubmit}
              initialValues={this.state.hotel}
              render={({ handleSubmit, pristine, invalid }) => (
                <form onSubmit={handleSubmit} >
                    <div className="col-md-8"><h4 className="hotel-highlight"></h4></div>
                <FormGroup>
                        <Field
                            name="name"
                            type="text"
                            component={renderTextField}
                            label="Name"
                            placeholder="Name of the group traveling"
                            />
                        <Field
                            name="email"
                            component={renderTextField}
                            label="Email"
                            placeholder="john@example.com"
                            validate={required}
                            />
                    </FormGroup>
                    { errors !== undefined && errors.FORM_ERROR && (
                    <p className="alert alert-danger">{errors.FORM_ERROR}</p>
                    )}
                    { errors !== undefined && errors.note && (
                    <p className="alert alert-danger">{errors.note}</p>
                    )}
                    <FormGroup>
                        <ButtonToolbar>
                            <Button
                            disabled={false}
                            bsStyle="success"
                            type="submit"
                            >
                            Save
                            </Button>
                            <Button
                            disabled={false}
                            bsStyle="success"
                            onClick={this.handleClose}
                            >
                            Cancel
                            </Button>
                        </ButtonToolbar>
                    </FormGroup>
                </form>
              )}
             /> 
            </Modal.Body>
            <Modal.Footer>
            
            </Modal.Footer>
          </Modal>
          <div className="row">
            <StyledGriddle
              data={convertedBids}
              sortProperties={sortProperties}
            >
              <RowDefinition>
                <ColumnDefinition id="name" title="Name" width={450}/>
                <ColumnDefinition id="email" title="Email" width={450}/>
                <ColumnDefinition id="id" title="Actions" customComponent={ButtonColumn} width={100}/>
              </RowDefinition>
            </StyledGriddle>
          </div>
        </div>  
       
      );
    }
  }


  
  export default HotelContactModal;
    // export default reduxForm({
    //         form: 'HotelContactModal', // a unique identifier for this form
    //   destroyOnUnmount: false                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    // })(HotelContactModal);
  
  //  const selector = formValueSelector('HotelContactModal');

  //  HotelContactModal = connect(
  //    state => {
  //     name = selector(state, 'name'),
  //     email = selector(state, 'email')
  //     return{
  //       name,
  //       email
  //     }
  //    }
  //  )(HotelContactModal)

// const mapStateToProps = state => {
//    return {
//     name: selector(state, 'name'),
//     email: selector(state, 'email') 
//    }

// }

//export default (HotelContactModal)


// WEBPACK FOOTER //
// src/routes/hotels/components/HotelContactModal.js